import NotFound from './pages/404.svelte';
import Home from './pages/home.svelte';
import Archive from './pages/archive.svelte';
import Payment from './pages/payment.svelte';
import Password from './pages/password.svelte';
import Verify from './pages/verify.svelte';
import Cancel from './pages/cancel.svelte';
import Stream from './pages/stream.svelte';
import Recording from './pages/recording.svelte';

export default {
    notFound: NotFound,
    home: Home,
    archive: Archive,
    payment: Payment,
    password: Password,
    verify: Verify,
    cancel: Cancel,
    stream: Stream,
    recording: Recording
};